import { render } from "./SubscribeTab.vue?vue&type=template&id=63a916da"
import script from "./SubscribeTab.vue?vue&type=script&lang=js"
export * from "./SubscribeTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__